import React, {useEffect} from "react";

// types
import { Order } from "../../../../types/orders/order";
import { DateRange } from "../../../../types/common";

// components
import BudgetsContent from "./Budgets.content";
import BudgetsView from "./BudgetsView";
import {dateToShortDateString, getDefaultDates, setCurrentTab} from "../../../../utils/functions";
import { DownloadButton } from "../../../../utils/exportButton";
import { useClassicView } from "../../../../config/classicView";

interface Props {
  orders: Order[];
  fetchingOrders: boolean;
  getOrdersRequest: (data: any, params: any) => Promise<void>;
  //filters
  rangeDate: DateRange;
  activeFilters: any;
  sendFilters: () => void;
  take: number;
  skip: number;
  total: number;
  featuresAllowed: string[];
}

export default (props: Props) => {
  const dateSince = dateToShortDateString(props.rangeDate.start) || getDefaultDates().start;
  const dateUntil = dateToShortDateString(props.rangeDate.end) || getDefaultDates().end;

  useEffect(() => {
    setCurrentTab('budgets');

    const dataQuery = {
      filter: props.activeFilters.filter,
      skip: props.skip,
      take: props.take,
    };
    const params = {
      dateSince, dateUntil
    };

    props.getOrdersRequest(dataQuery, params);
  }, []);

  const exportParams = {
    query: {
      dateSince,
      dateUntil,
      format: "odb",
      entity: "budgets"
    },
    body: {
      filters: props.activeFilters
    }
  };
  const exportButton = () => (
      <DownloadButton endpoint="/api/Orders" params={exportParams} method="post">Descargar todos</DownloadButton>
  );

  const { classic } = useClassicView();
  const Content = classic ? BudgetsContent : BudgetsView;

  return (
      <Content
          tableData={props.orders}
          fetchingOrders={props.fetchingOrders}
          exportButton={exportButton}
          sendFilters={props.sendFilters}
          take={props.take}
          skip={props.skip}
          total={props.total}
          activeFilters={props.activeFilters}
          featuresAllowed={props.featuresAllowed}
      />
  );
};
